import { actions } from "../../utils/constants";


const initialState = {
    open: false,
    component: <></>,
    title: "",
    onConfirm: () => {

    },
    onCancle: () => {

    },
    confirmText: "Submit",
    resetText: "Cancel",
    size: 'md',
    dialogProps:{},
    loading:false

}
const modalReducer = (state = initialState, action) => {

    switch (action.type) {
        case actions.OPEN_MODAL: return {
            ...state,
            open: true,
            component: action.component,
            size: action.size,
            title: action.title,
            onConfirm: action.onConfirm ?? null,
            onCancle: action.onCancle ?? null,
            dialogProps:action.dialogProps??{},
            confirmText: action.confirmText ?? "Submit",
            resetText: action.resetText ?? "Cancel",

        };
        case actions.LOADING_TRUE: return { ...state, loading:true };
        case actions.CLOSE_MODAL: return { ...state, open:false,onConfirm:null,onCancle:null,title:null ,loading:false};
        default: return { ...state }
    }

}
export default modalReducer